export const MOUSE_WHEEL_EVENTS = ['DOMMouseScroll', 'mousewheel', 'wheel'];
